export default __webpack_public_path__ + "static/media/STATREP - Mt Vernon.f21484de.pdf";